import { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Download, Share2, Copy, ExternalLink } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Vertical 9:16 hero-product reels — 15 s each, ready for IG Reels / TikTok / Shorts.
// Each reel ships with its own product-specific caption so ambassadors can
// paste-and-post without editing.
const HERO_REELS = [
  {
    id: "rise_hoodie",
    title: "Rise II Power · Pullover Hoodie",
    price: "$65",
    tagline: "Heavyweight fleece · chrome print",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "This is the $65 Rise II Power Pullover Hoodie 🖤\n\n" +
      "Heavyweight fleece · chrome-print seal · built to move a movement.\n\n" +
      "Every hoodie sold sends 25% straight to the Trillion Dollar Spending Power Fund at Citizen Trust Bank — funding Black-owned manufacturing, grocers, banks, and franchises. Wear the mission. Fund the future.\n\n" +
      "🛒 Shop it → blackdollarsunited.org\n\n" +
      "🎵 Music by Rise II Power → IG @rise2powermusic · TikTok @rise2music0 · YT @rise2power532 · FB Rise2PowerMusicEmpire\n\n" +
      "#BlackDollarsUnited #RiseIIPower #TrillionDollarSpendPower #BlackOwned #SupportBlackBusiness #BuyBlack #BlackWealth #GroupEconomics #BlackExcellence #StreetwearWithPurpose",
  },
  {
    id: "rise_movement_tee",
    title: "Rise II Power · Movement Tee",
    price: "$45",
    tagline: "Special edition · smoke silhouette",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "The $45 Rise II Power MOVEMENT Tee — special edition 🔥\n\n" +
      "Smoke silhouette · midnight cotton · one-of-one energy. This isn't merch. It's a uniform.\n\n" +
      "25% of every sale flows straight to the Trillion Dollar Spending Power Fund at Citizen Trust Bank. You wear it → we build with it. Grocers. Banks. Franchises. Ownership.\n\n" +
      "🛒 Cop the drop → blackdollarsunited.org\n\n" +
      "🎵 Music by Rise II Power → IG @rise2powermusic · TikTok @rise2music0 · YT @rise2power532 · FB Rise2PowerMusicEmpire\n\n" +
      "#BlackDollarsUnited #RiseIIPower #TheMovement #TrillionDollarSpendPower #BlackOwned #BuyBlack #SupportBlackBusiness #BlackWealth #GroupEconomics #StreetwearRevolution",
  },
  {
    id: "rise_special_cap",
    title: "Rise II Power · Black-Silver Cap",
    price: "$45",
    tagline: "Structured 6-panel · silver stitch",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "$45 · Rise II Power Special Edition Black-Silver Cap ⚡\n\n" +
      "Structured 6-panel · gold-thread lining · silver-stitch seal · adjustable strapback. Everyday flex, all-day mission.\n\n" +
      "Every cap sold puts 25% into the Trillion Dollar Spending Power Fund at Citizen Trust Bank. Black-owned businesses funded. Community wealth built. This is what group economics looks like.\n\n" +
      "🛒 Shop → blackdollarsunited.org\n\n" +
      "🎵 Music by Rise II Power → IG @rise2powermusic · TikTok @rise2music0 · YT @rise2power532 · FB Rise2PowerMusicEmpire\n\n" +
      "#BlackDollarsUnited #RiseIIPower #TrillionDollarSpendPower #BlackOwned #BuyBlack #SnapbackSeason #StreetwearWithPurpose #BlackWealth #GroupEconomics #WearTheMovement",
  },
  {
    id: "bdu_signature_tee",
    title: "BDU · Signature Tee",
    price: "$40",
    tagline: "Own the movement · wear the mission",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "The $40 BDU Signature Tee 🖤✨\n\n" +
      "Midnight cotton · gold circular seal · center-mass · print-quality luxury at everyday pricing. The tee you wear when you show up for your people.\n\n" +
      "25% of every Signature Tee funds Black-owned businesses through the Trillion Dollar Spending Power Fund at Citizen Trust Bank. You buy → we build.\n\n" +
      "🛒 Get yours → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #BDU #TrillionDollarSpendPower #BlackOwned #BuyBlack #SupportBlackBusiness #BlackWealth #GroupEconomics #BlackExcellence #OwnTheMovement",
  },
  {
    id: "bdu_original_tee",
    title: "BDU · Original Logo Tee",
    price: "$40",
    tagline: "The classic · chrome print on black",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "The $40 BDU Original Logo Tee — the classic 🖤\n\n" +
      "Chrome print · fist-and-flag emblem · black-on-black attitude. Where every dollar you spend on us circles back to us.\n\n" +
      "25% of every tee goes directly into the Trillion Dollar Spending Power Fund at Citizen Trust Bank — capital for Black-owned businesses, real ownership for our community.\n\n" +
      "🛒 Shop → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #BDU #OriginalLogoTee #TrillionDollarSpendPower #BlackOwned #BuyBlack #SupportBlackBusiness #BlackWealth #GroupEconomics #ChromePrint",
  },
  {
    id: "bdu_trillion_cap",
    title: "BDU · Trillion Cap",
    price: "$30",
    tagline: "Snapback · gold-on-black seal",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "$30 · The Trillion Cap 👑\n\n" +
      "Snapback · gold-on-black BDU seal · everyday crown for the movement. Low ticket, high mission.\n\n" +
      "Every $30 cap sends $7.50 into the Trillion Dollar Spending Power Fund at Citizen Trust Bank — building Black-owned wealth one head at a time.\n\n" +
      "🛒 Grab yours → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #TrillionCap #TrillionDollarSpendPower #BlackOwned #BuyBlack #SnapbackSeason #SupportBlackBusiness #BlackWealth #GroupEconomics #EverydayCrown",
  },
];

const ASSETS = [
  {
    id: "trillion_dollar_fcu_announcement",
    kind: "video",
    title: "PROPOSED TRILLION DOLLAR SPENDING POWER · Federal Credit Union Announcement",
    subtitle: "3:31 · MP4 · 1080×1920 vertical · Founder narration by Greg L Bradford · Charter announcement",
    description:
      "Cinematic vertical announcement for the **PROPOSED TRILLION DOLLAR SPENDING POWER FEDERAL CREDIT UNION** — pending charter approval from the National Credit Union Association (NCUA) upon raising $500,000 in seed capital held in escrow at Citizen Trust Bank alongside the Trillion Dollar Spending Power Fund. Founder, CEO & President: **Greg L Bradford**. Built on the user-generated Gemini reference footage (upscaled 720×1280 → 1080×1920 with lanczos + hqdn3d + unsharp, warm-gold cinematic grade, vignette + grain) with the founder's 3:31 narration loud-normalized to -13.7 LUFS and every key charter beat baked in as gold-bordered center bumpers: PENDING NCUA CHARTER APPROVAL → SEED CAPITAL GOAL $500,000 → IN ESCROW AT CITIZEN TRUST BANK → FOUNDER · CEO · PRESIDENT · GREG L BRADFORD. Closes on a full-screen \"CONTROL OUR DOLLARS\" end card with pulsing blackdollarsunited.org URL. Post-ready for Reels / TikTok / Shorts / Facebook Reels.",
    src: "/api/static/marketing/trillion_dollar_fcu_announcement.mp4",
    poster: "/api/static/marketing/_sources/credit_union/announcement_poster.jpg",
    caption:
      "🏦 COMING SOON — PROPOSED TRILLION DOLLAR SPENDING POWER FEDERAL CREDIT UNION\n\n" +
      "@allblackdollarsunite is chartering a brand-new NCUA-regulated federal credit union built for the people, by the people.\n\n" +
      "✅ SEED CAPITAL GOAL: $500,000\n" +
      "✅ Escrowed at Citizen Trust Bank alongside the Trillion Dollar Spending Power Fund\n" +
      "✅ Pending CHARTER APPROVAL from the National Credit Union Association (NCUA)\n" +
      "✅ Founder · CEO · President: GREG L BRADFORD\n\n" +
      "Once approved, Black Dollars United members will bank, save, borrow, and build wealth inside a Black-owned community credit union that recirculates every dollar back into our own communities.\n\n" +
      "🏦 Pledge → blackdollarsunited.org\n" +
      "🏛️ Escrow held at Citizen Trust Bank · Member FDIC\n\n" +
      "#BlackDollarsUnited #TrillionDollarSpendingPower #FederalCreditUnion #NCUA #GregLBradford #CitizenTrustBank #ControlOurDollars #BlackWealth #GroupEconomics #BuyBlack #BlackOwned #RiseIIPower",
  },
  {
    id: "sekhem_social_v1",
    kind: "video",
    title: "Sekhem Re · Social Media Content",
    subtitle: "37 sec · MP4 · 1080×1920 vertical · $50M / Trillion Dollar Fund CTA overlays baked · Ready for Facebook / TikTok / YouTube / Reels / Shorts",
    description:
      "Post-ready 37-second social clip of Sekhem Re speaking the Black Dollars United mission. Background music mixed under his voice at broadcast-safe levels (-15 LUFS) and full $50M / Trillion Dollar Spending Power Fund / CITIZEN TRUST BANK / blackdollarsunited.org overlays baked in — persistent gold pill top-right, rotating bottom-banner CTAs, and a full-screen $50 MILLION end card with a pulsing URL. Download the MP4 and post it straight to Facebook, TikTok, Instagram Reels, and YouTube Shorts. No editing required.",
    src: "/api/static/marketing/sekhem_social_v1.mp4",
    poster: "/api/static/marketing/_sources/sekhem/social_poster.jpg",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "🎙️ Sekhem Re on the mission — Black Dollars United.\n\n" +
      "$50 MILLION in 2 years. $1 TRILLION in Black spending power. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund — capital for Black-owned businesses, grocers, banks, manufacturing, and franchises across America.\n\n" +
      "We spend $1.6 TRILLION every year. Less than 2% recirculates inside our own neighborhoods. That ends now.\n\n" +
      "🏦 Pledge → blackdollarsunited.org\n🛒 Shop the movement → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #SekhemRe #TrillionDollarSpendPower #RiseIIPower #BlackWealth #GroupEconomics #BuyBlack #SupportBlackBusiness #BlackOwned",
  },
  {
    id: "sekhem_social_v2",
    kind: "video",
    title: "Sekhem Re · Social Media Content — Take 2",
    subtitle: "40 sec · MP4 · 1080×1920 vertical · Voice-sync captions · $50M math callout + full CTA overlays · Ready for Facebook / TikTok / YouTube / Reels / Shorts",
    description:
      "Second post-ready vertical clip of Sekhem Re speaking directly to camera in front of the Black Dollars United backdrop. Landscape source is converted to 1080×1920 with a heavy blur-fill background (industry-standard for Reels/TikTok) so nothing feels cropped. Features **pop-style voice-sync captions** (Whisper-transcribed and burned into the top blur-fill band, 2-3 words at a time) so the reel plays perfectly sound-off on IG / FB / TikTok feeds. Also includes the powerful math callout — **500,000 PEOPLE × $100 = $50 MILLION** — plus the persistent gold top pill, rotating bottom banner CTAs, and a full-screen $50 MILLION end card with pulsing blackdollarsunited.org URL. Background music (same track as Take 1) fades in from 0:37 and fades out cleanly at the video end. Download the MP4 and post it straight to Facebook, TikTok, Instagram Reels, and YouTube Shorts. No editing required.",
    src: "/api/static/marketing/sekhem_social_v2.mp4",
    poster: "/api/static/marketing/_sources/sekhem/social_v2_poster.jpg",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "🎙️ Sekhem Re on the math — Black Dollars United.\n\n" +
      "500,000 people × $100 = $50 MILLION.\n\n" +
      "That's all it takes. One hundred dollars from half a million of us and the Trillion Dollar Spending Power Fund at Citizen Trust Bank funds Black-owned businesses, grocers, banks, manufacturing, and franchises across America.\n\n" +
      "We spend $1.6 TRILLION every year. Less than 2% recirculates inside our own neighborhoods. That ends now.\n\n" +
      "🏦 Pledge $100 → blackdollarsunited.org\n🛒 Shop the movement → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #SekhemRe #500KStrong #TrillionDollarSpendPower #RiseIIPower #BlackWealth #GroupEconomics #BuyBlack #SupportBlackBusiness #BlackOwned",
  },
  {
    id: "rise2power_session_hero_v2",
    kind: "video",
    title: "RISE II POWER SESSION · SEKHEM RE feat. DJ BLACK CHARM (Full Hero · v2)",
    subtitle: "2:38 · MP4 · 1920×1080 · Sekhem storefront preamble with baked overlays → cinematic banner intro → studio session → committee outro",
    description:
      "The full 2:38 hero cut. Opens with a 25 s Sekhem-on-the-ground preamble outside the C&R Caribbean Jerk Restaurant — now with the persistent **BLACK DOLLARS UNITED · $50M FUND** and **RISE II POWER · SEKHEM RE** gold pills locked in, plus a rotating bottom banner cycling through **$50 MILLION IN 2 YEARS → TRILLION DOLLAR SPENDING POWER FUND → BLACK DOLLAR$ UNITED · CITIZEN TRUST BANK → PLEDGE AT BLACKDOLLARSUNITED.ORG**. Rolls straight into the cinematic gold-heist banner intro (12 s), the color-graded studio session with Sekhem's live vocals + DJ BLACK CHARM bed underneath (1:55), and closes on the NOW ASSEMBLING THE FINANCIAL COMMITTEE outro card with pulsing blackdollarsunited.org (6 s). Broadcast-safe audio, drop-and-post ready for YouTube / Facebook / TV.",
    src: "/api/static/marketing/rise2power_session_hero_v2.mp4",
    poster: "/api/static/marketing/_sources/wa_video/hero_v2_poster.jpg",
    caption:
      "🎙️ RISE II POWER SESSION · v2 (verification cut)\n@rise2powermusic  ·  @allblackdollarsunite\n\n" +
      "Sekhem Re on the ground — from the storefront to the studio to the vault. Verify pacing here before we lock the banner overlays on the preamble.\n\n" +
      "🏦 $50 MILLION in 2 years. 500,000 of us. $100 each. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund.\n\n" +
      "🏦 Pledge → blackdollarsunited.org\n🎤 Submit your music → rise2power.org\n\n" +
      "🎵 Beat: DJ BLACK CHARM\n\n" +
      "#BlackDollarsUnited #SekhemRe #DJBLACKCHARM #RiseIIPower #TrillionDollarSpendPower #StudioSession",
  },
  {
    id: "rise2power_session_hero",
    kind: "video",
    title: "RISE II POWER SESSION · SEKHEM RE feat. DJ BLACK CHARM",
    subtitle: "2:13 · MP4 · 1920×1080 · All-in-one hero video · Cinematic banner intro → studio session → committee outro",
    description:
      "The full hero cut. Cinematic gold-heist banner intro opens on the vintage Trillion Dollar Spending Power Fund vault (12 s), rolls straight into the color-graded studio session with Sekhem Re performing in front of the vault banner while his live vocals stay perfectly synced and the DJ BLACK CHARM track sits underneath as a musical bed (1:55), and closes on the NOW ASSEMBLING THE FINANCIAL COMMITTEE recruitment card with a pulsing blackdollarsunited.org URL (6 s). Persistent gold RISE II POWER · STUDIO SESSION pill baked into the main body. Broadcast-safe audio (-14 LUFS, -1 dBFS peak). Drop it as-is on YouTube, Facebook, or TV — no editing required.",
    src: "/api/static/marketing/rise2power_session_hero.mp4",
    poster: "/api/static/marketing/_sources/wa_video/hero_poster.jpg",
    caption:
      "🎙️ RISE II POWER SESSION\n@rise2powermusic  ·  @allblackdollarsunite\n\n" +
      "SEKHEM RE feat. DJ BLACK CHARM — inside the studio, in front of the vault, at the heart of the movement.\n\n" +
      "$50 MILLION in 2 years. 500,000 of us. $100 each. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund — funding Black-owned businesses, grocers, banks, manufacturing, and franchises across America.\n\n" +
      "🏦 NOW ASSEMBLING THE FINANCIAL COMMITTEE — seeking highly motivated founders to RISE II POWER and revitalize hoods into beautiful, safe communities.\n\n" +
      "🏦 Pledge $100 → blackdollarsunited.org\n🎤 Submit your music → rise2power.org\n🛒 Shop the movement → blackdollarsunited.org\n\n" +
      "🎵 Beat: DJ BLACK CHARM\n\n" +
      "#BlackDollarsUnited #SekhemRe #DJBLACKCHARM #RiseIIPower #TrillionDollarSpendPower #StudioSession #FinancialCommittee #BlackWealth #GroupEconomics #BuyBlack #BlackOwned",
  },
  {
    id: "rise2power_studio_session",
    kind: "video",
    title: "RISE II POWER · Studio Session (Sekhem Re feat. DJ BLACK CHARM)",
    subtitle: "1:55 · MP4 · 1920×1080 · Studio session cut · Vault Banner Backdrop",
    description:
      "Cinematic behind-the-scenes studio session with Sekhem Re performing in front of the physical Trillion Dollar Spending Power Fund vault banner. Low-res source was upscaled to 1920×1080 with lanczos + hqdn3d + unsharp for a crisp cinematic look, warm-gold color graded, subtle vignette + grain baked in. Audio: Sekhem's live studio vocals as the primary track (perfect lip sync) with the DJ BLACK CHARM track underneath as a musical bed at 24% volume. Broadcast-normalized to -14 LUFS with a -1 dBTP intersample ceiling — perfect for IG / TikTok / YouTube / Facebook. Music fades in over 1.5 s at the start, fades out over the final 3 s while the video crossfades to black. A persistent gold RISE II POWER · STUDIO SESSION pill sits in the top-right so the label reads at every scrub. Post-ready.",
    src: "/api/static/marketing/rise2power_studio_session.mp4",
    poster: "/api/static/marketing/_sources/wa_video/session_poster.jpg",
    caption:
      "🎙️ @rise2powermusic  ·  @allblackdollarsunite\n\n" +
      "STUDIO SESSION 🎵\n\n" +
      "Sekhem Re feat. DJ BLACK CHARM · behind the mic, inside the empire, standing in front of the vault where the Trillion Dollar Spending Power Fund lives.\n\n" +
      "$50 MILLION in 2 years. 500,000 of us. $100 each. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund — funding Black-owned businesses, grocers, banks, manufacturing, and franchises across America.\n\n" +
      "🏦 Pledge $100 → blackdollarsunited.org\n🎤 Submit your music → rise2power.org\n🛒 Shop the movement → blackdollarsunited.org\n\n" +
      "🎵 Beat: DJ BLACK CHARM\n\n" +
      "#BlackDollarsUnited #SekhemRe #DJBLACKCHARM #RiseIIPower #TrillionDollarSpendPower #StudioSession #BlackWealth #GroupEconomics #BuyBlack #BlackOwned #TheAnthem",
  },
  {
    id: "bdu_banners_reveal_vertical",
    kind: "video",
    title: "Banner Reveal · Vertical (Gold-Heist Showcase)",
    subtitle: "18 sec · MP4 · 1080×1920 · Cinematic banner showcase · Silent for post · Reels / TikTok / Shorts",
    description:
      "Cinematic 18-second gold-heist reveal built to introduce both marquee brand banners. **Scene 1 (0-6 s)** — Ken Burns push on the vintage bronze **Trillion Dollar Spending Power Fund** vault with the embossed reveal 'THE POWER OF / THE BLACK DOLLAR'. **Scene 2 (6-12 s)** — the **BLACK DOLLAR$ UNITED** cloth banner unveils on a blur-fill studio backdrop with a '500,000 STRONG · $100 EACH · $50 MILLION' ticker. **Scene 3 (12-18 s)** — dark scrim + big serif 'NOW ASSEMBLING / THE FINANCIAL COMMITTEE' with the recruitment message and a pulsing blackdollarsunited.org URL. Warm-gold color grade, subtle vignette + film grain, elegant fade transitions between scenes. **Silent audio track** so you can drop Sekhem's speech and music straight in without re-encoding video.",
    src: "/api/static/marketing/bdu_banners_reveal_vertical.mp4",
    poster: "/api/static/marketing/_sources/banners/reveal_v_poster.jpg",
    caption:
      "🏦 THE VAULT IS OPEN.\n\n" +
      "TRILLION DOLLAR SPENDING POWER · BLACK DOLLAR$ UNITED\n\n" +
      "$50 MILLION in 2 years. 500,000 of us. $100 each. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund.\n\n" +
      "NOW ASSEMBLING THE FINANCIAL COMMITTEE — seeking highly motivated founders to RISE II POWER and revitalize hoods into beautiful, safe communities.\n\n" +
      "🏦 Pledge $100 → blackdollarsunited.org\n🎤 Join the committee → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #TrillionDollarSpendPower #RiseIIPower #500KStrong #TheVault #ThePowerOfTheBlackDollar #GroupEconomics #BuyBlack #BlackOwned",
  },
  {
    id: "bdu_banners_reveal_horizontal",
    kind: "video",
    title: "Banner Reveal · Horizontal (Gold-Heist Showcase)",
    subtitle: "18 sec · MP4 · 1920×1080 · Cinematic banner showcase · Silent for post · YouTube / Facebook feed / TV",
    description:
      "Horizontal 1920×1080 companion cut of the cinematic gold-heist banner reveal — same three scenes, same warm-gold grade, sized for YouTube / Facebook feed / TV / boardroom playback. **Silent audio track** so you can drop Sekhem's speech and music straight in without re-encoding video.",
    src: "/api/static/marketing/bdu_banners_reveal_horizontal.mp4",
    poster: "/api/static/marketing/_sources/banners/reveal_h_poster.jpg",
    caption:
      "🏦 THE VAULT IS OPEN.\n\n" +
      "TRILLION DOLLAR SPENDING POWER · BLACK DOLLAR$ UNITED\n\n" +
      "$50 MILLION in 2 years. 500,000 of us. $100 each. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund.\n\n" +
      "NOW ASSEMBLING THE FINANCIAL COMMITTEE — seeking highly motivated founders to RISE II POWER and revitalize hoods into beautiful, safe communities.\n\n" +
      "🏦 Pledge $100 → blackdollarsunited.org\n\n" +
      "#BlackDollarsUnited #TrillionDollarSpendPower #RiseIIPower #500KStrong #TheVault #ThePowerOfTheBlackDollar #GroupEconomics #BuyBlack #BlackOwned",
  },
  {
    id: "rise2power_commercial_v1",
    kind: "video",
    title: "Rise II Power — Talent Recruitment Commercial",
    subtitle: "90 sec · MP4 · 1280×720 · BMW 360° Illumination Reveal · Newt-Jorgiana Signed-Artist Spotlight",
    description:
      "Cinematic 90-second recruitment commercial for the Rise II Power Music Empire. Studio establishing shots → **360° BMW ILLUMINATION REVEAL** (matte-black M5 rotating turntable with 'MUSIC EMPIRE' glowing warm-gold in the front kidney grille, 'RISE II POWER' underglow LED lettering beneath the side skirts on both driver and passenger flanks, and 'THE HOTTEST LABEL IN THE GAME' illuminated across the lower trunk lid on the rear) → Greg L. Bradford founder card → Shadow Soulja Muziq title card → **NEWT-JORGIANA SIGNED-ARTIST SPOTLIGHT** → editorial nightclub + penthouse dancer scenes → SUBMIT YOUR MUSIC CTA with rise2power.org + all social handles → cinematic **THE RISE OF AN EMPIRE** signature closing card in smoke-silver letters with Greg L. Bradford credit and pulsing rise2power.org URL. RISE II POWER flash-brand stamped on the top-right corner every 4 seconds so the label reads at any glance. Ready for IG, YouTube, TV/streaming pre-roll.",
    src: "/api/static/marketing/rise2power_commercial_v1.mp4",
    poster: "/api/static/marketing/_sources/rise_commercial/bmw_front.jpg",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "🎬 RISE II POWER MUSIC EMPIRE — THE HOTTEST LABEL IN THE GAME. THE RISE OF AN EMPIRE.\n\n" +
      "We're looking for the hottest talent in the game. Bring your fire. Bring your vision. We'll build the empire.\n\n" +
      "🌟 Featuring signed artist NEWT-JORGIANA — the hottest name on the Rise II Power roster.\n\n" +
      "🎤 Submit your music → rise2power.org\n📧 greg@rise2power.org\n\n" +
      "Founders:\n· Greg L. Bradford — Founder · CEO · President\n· Shadow Soulja Muziq — Founder · CEO · President · SEKHEM RE\n\n" +
      "🎵 Song: Newt-Jorgiana feat. HiSociety Dolla\n\n" +
      "🎵 Follow → IG @rise2powermusic · TikTok @rise2music0 · YT @rise2power532 · FB Rise2PowerMusicEmpire\n\n" +
      "#RiseIIPower #RiseIIPowerMusicEmpire #NewtJorgiana #SekhemRe #HipHop #RnB #IndieLabel #ATLMusic #MusicIndustry #NewMusic #BlackOwned #TheHottestLabelInTheGame",
  },
  {
    id: "rise2power_vertical_60s",
    kind: "video",
    title: "Rise II Power — Vertical Cut (Reels / TikTok / Shorts)",
    subtitle: "60 sec · MP4 · 1080×1920 · Ends on rise2power.org submit CTA",
    description:
      "60-second vertical (9:16) re-cut of the Rise II Power recruitment commercial — reframed for Instagram Reels, TikTok, and YouTube Shorts. Blurred-pillarbox composition so no BMW, dancer, or founder shot gets cropped. Closes on a full-screen \"SUBMIT AT RISE2POWER.ORG\" end card that points viewers straight to the /join-the-label submission page. Post it, boost it, share it — every tap lands on the MP3 upload form.",
    src: "/api/static/marketing/rise2power_vertical_60s.mp4",
    poster: "/api/static/marketing/_sources/rise_commercial/bmw_front.jpg",
    caption:
      "The label is open. Submit your track at rise2power.org 🎤\n\n" +
      "🎵 Song: Newt-Jorgiana feat. HiSociety Dolla\n\n" +
      "#Rise2Power #BlackDollarUnited",
  },
  {
    id: "sekhem_bdu_anthem_v1",
    kind: "video",
    title: "Sekhem Re · Black Dollars United Anthem",
    subtitle: "3:28 · MP4 · 1080×1920 · Vertical Reels/TikTok/Shorts · Sekhem Re narration",
    description:
      "Cinematic 3½-minute vertical anthem for the Trillion Dollar Spending Power Fund — Sekhem Re speaks the mission over six Nano-Banana-generated B-roll scenes (Kingdom rise · Gold vault · Black-owned business row · Unity rally · Pharaoh-gold portrait · Legacy hands). Auto-transcribed with Whisper and every keyword slams across the screen in sync with his delivery. Ends on the full $50M / 2-year Trillion Dollar Spending Power Fund call-to-action with blackdollarsunited.org. Built for IG Reels, TikTok, YouTube Shorts, and the pinned post on every founder channel.",
    src: "/api/static/marketing/sekhem_bdu_anthem_v1.mp4",
    poster: "/api/static/marketing/_sources/sekhem/bg_05_pharaoh_gold.jpg",
    caption:
      "📲 @ALLBLACKDOLLARSUNITE\n\n" +
      "🎙️ SEKHEM RE speaks the mission — Black Dollars United.\n\n" +
      "$50 MILLION in 2 years. $1 TRILLION in spending power. All of it pooled at Citizen Trust Bank inside the Trillion Dollar Spending Power Fund — funding Black-owned businesses, grocers, banks, manufacturing, and franchises across America.\n\n" +
      "We spend $1.6 TRILLION every year. Less than 2% recirculates in our own neighborhoods. That ends now.\n\n" +
      "Every dollar you pledge → owns the block. Builds the vault. Rewrites the legacy.\n\n" +
      "🏦 Pledge → blackdollarsunited.org\n🛒 Shop the movement → blackdollarsunited.org\n\n" +
      "🎙️ Voice: Sekhem Re · Founder · Rise II Power Music Empire\n\n" +
      "#BlackDollarsUnited #SekhemRe #TrillionDollarSpendPower #RiseIIPower #BlackWealth #GroupEconomics #BuyBlack #SupportBlackBusiness #BlackOwned #TheAnthem",
  },
  {
    id: "spending_v1",
    kind: "video",
    title: "Spending Power Reality Check",
    subtitle: "80 sec · MP4 · 1280×720 · Chop-and-Screw DJ Mix",
    description:
      "Reality-check reel: every year Black America spends $84B+ outside our own economy — $11B on alcohol, $6.6B on hair care & wigs, $9B on skin & beauty, $41B eating out, and $17B on recreation. This video walks the viewer through each category with cinematic editorial imagery, big gold stat cards, and a chopped-and-screwed DJ mix, then closes with the redirect: send just 1 in 4 dollars back — $21B — into the Trillion Dollar Spending Power Fund. Perfect for community screenings, IG feed, and the pitch deck.",
    src: "/api/static/marketing/bdu_spending_power_v1.mp4",
    poster: "/api/static/marketing/spending_scenes/04_eating_out.jpg",
    caption:
      "$84 BILLION every year. That's what our community spends on beer, wigs, restaurants, streaming, and skincare — dollars that leave our neighborhoods the same day they're earned. Redirect just 1 in 4 dollars → $21 BILLION → into the Black Dollars United Trillion Dollar Spending Power Fund at Citizen Trust Bank. Own the block. Fund the future. blackdollarsunited.org · #BlackDollarsUnited #RiseIIPower #TrillionDollarSpendPower",
  },
  {
    id: "anthem_v1",
    kind: "video",
    title: "The Anthem — Rise II Power",
    subtitle: "60 sec · MP4 · 1280×720 · Rise II Power Anthem (1:30-2:30)",
    description:
      "Epic 5-scene cinematic reel: the RISE II POWER missile launches from an impoverished city street, ascends into space, and releases a swarm of golden flyers that rain down and revitalize the community. Scored to the Sekhem Re anthem (1:30–2:30 anthem drop). Closes on the thriving revitalized neighborhood with the full BlackDollarsUnited.org call-to-action.",
    src: "/api/static/marketing/bdu_anthem_v1.mp4",
    poster: "/api/static/marketing/anthem_scenes/01_launchpad.jpg",
    caption:
      "The mission takes off. From boarded-up storefronts to a thriving Black community — one dollar at a time. Rise II Power. Rise together. Shop the movement + pledge into the Trillion Dollar Spending Power Fund at blackdollarsunited.org. #BlackDollarsUnited #RiseIIPower #TrillionDollarSpendPower",
  },
  {
    id: "impact_v1",
    kind: "video",
    title: "The Movement — Impact Video",
    subtitle: "90 sec · MP4 · 1280×720 · Why the Trillion Dollar Spending Power Fund matters",
    description:
      "Long-form storytelling reel: how Black Dollars United rebuilds and revitalizes underserved communities. Text-overlay driven so viewers can follow every point even while scrolling with sound off — every line explains why the Fund matters, how it works, and where every dollar goes. Ready for Instagram/Facebook feed, LinkedIn, and community-event playback.",
    src: "/api/static/marketing/bdu_impact_v2.mp4",
    poster: "/api/static/marketing/bdu_flyer_v5.jpg",
    caption:
      "$1.6 trillion. That's what the Black community spends in America every year — and less than two percent recirculates inside our own neighborhoods. Black Dollars United is changing that. $50 million raised in 2 years, held in the Trillion Dollar Spending Power Fund at Citizen Trust Bank — funding Black-owned businesses, education, housing, and infrastructure. Jobs restored. Storefronts rebuilt. Generational wealth — built by us, for us. This is the movement. blackdollarsunited.org · #BlackDollarsUnited",
  },
  {
    id: "promo_v2",
    kind: "video",
    title: "Master Merch Hype Reel",
    subtitle: "40 sec · MP4 · 1280×720 · with Sekhem Re — Rise To Power",
    description:
      "Full-collection creative reel — cold-open headline, BDU Signature line, BDU Original Chrome series, then the Rise II Power cap and hoodie color-cycles (red · black · blue · white), the Movement smoke tee, joggers, special black cap, and a full flyer close with a pulsing URL. Drop it on Instagram Reels, TikTok, and Facebook.",
    src: "/api/static/marketing/bdu_promo_v2.mp4",
    poster: "/api/static/marketing/bdu_flyer_v5.jpg",
    caption:
      "We Got The Power. Now let's Rise II Power. Shop the full drop — BDU Signature, Original Logo Chrome, and every Rise II Power colorway — at blackdollarsunited.org. 25% of every sale goes directly into the Trillion Dollar Spending Power Fund at Citizen Trust Bank. #BlackDollarsUnited #RiseIIPower",
  },
  {
    id: "flyer_v1",
    title: "Master Merch Flyer",
    subtitle: "Portrait poster · 1600×2400 · JPG",
    description:
      "The complete Black Dollars United & Rise II Power collection on one obsidian poster. Share it on Instagram, Facebook, email blasts, or print it out for community events.",
    src: "/api/static/marketing/bdu_flyer_v5.jpg",
    caption:
      "We Got The Power. Now Let's Rise II Power. Shop the movement at blackdollarsunited.org — 25% of every sale goes directly into the Trillion Dollar Spending Power Fund at Citizen Trust Bank. #BlackDollarsUnited",
  },
];

export default function MarketingTab() {
  return (
    <div className="space-y-10" data-testid="admin-marketing-tab">
      <div>
        <div className="label-eyebrow mb-2">Marketing Kit</div>
        <h2 className="font-serif text-4xl text-bdu-cream">Share the movement.</h2>
        <p className="mt-3 text-bdu-cream/70 max-w-2xl text-sm leading-relaxed">
          Ready-to-post promotional assets pulling in every current merch drop. Download, share, print.
          Every asset drives buyers to blackdollarsunited.org.
        </p>
      </div>

      {ASSETS.map((asset) => (
        <AssetCard key={asset.id} asset={asset} />
      ))}

      <HeroReelsGrid />
    </div>
  );
}

function HeroReelsGrid() {
  return (
    <div className="pt-6 border-t border-bdu-gold/20" data-testid="hero-reels-section">
      <div className="mb-6">
        <div className="label-eyebrow mb-2">Product Hero Reels</div>
        <h3 className="font-serif text-3xl text-bdu-cream">Post one a day. Watch sales stack.</h3>
        <p className="mt-2 text-bdu-cream/70 max-w-2xl text-sm leading-relaxed">
          Six 15-second vertical (9:16) reels — one per hero SKU. Ready to post on Instagram Reels, TikTok, and YouTube Shorts. Each reel ships with its own product-specific caption + hashtags + link. Tap <span className="text-bdu-gold">Copy Caption</span> and paste straight into your post.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {HERO_REELS.map((reel) => (
          <HeroReelCard key={reel.id} reel={reel} />
        ))}
      </div>
    </div>
  );
}

function HeroReelCard({ reel }) {
  const src = `${BACKEND}/api/static/marketing/reels/reel_${reel.id}.mp4`;

  const copyCaption = () => {
    navigator.clipboard.writeText(reel.caption).then(
      () => toast.success(`${reel.title} caption copied`),
      () => toast.error("Couldn't copy caption")
    );
  };

  return (
    <div
      className="border border-bdu-gold/20 bg-bdu-surface p-3 flex flex-col"
      data-testid={`hero-reel-${reel.id}`}
    >
      <div className="relative bg-black">
        <video
          src={src}
          controls
          playsInline
          preload="metadata"
          className="w-full h-auto"
          style={{ aspectRatio: "9/16" }}
          data-testid={`hero-reel-video-${reel.id}`}
        />
      </div>
      <div className="mt-3 flex-1">
        <h4 className="text-bdu-cream text-sm leading-tight" data-testid={`hero-reel-title-${reel.id}`}>{reel.title}</h4>
        <div className="text-xs text-bdu-gold mt-1" data-testid={`hero-reel-price-${reel.id}`}>{reel.price} · {reel.tagline}</div>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button
          onClick={copyCaption}
          className="btn-ghost text-xs inline-flex items-center justify-center gap-2 py-2"
          data-testid={`hero-reel-copy-caption-${reel.id}`}
        >
          <Copy size={13} /> Copy Caption
        </button>
        <a
          href={src}
          download={`reel_${reel.id}.mp4`}
          className="btn-gold text-xs inline-flex items-center justify-center gap-2 py-2"
          data-testid={`hero-reel-download-${reel.id}`}
        >
          <Download size={13} /> Download MP4
        </a>
      </div>
    </div>
  );
}

function AssetCard({ asset }) {
  const [regenBusy, setRegenBusy] = useState(false);
  const fullUrl = `${BACKEND}${asset.src}`;
  const isVideo = asset.kind === "video";
  const downloadName = isVideo ? `${asset.id}.mp4` : `${asset.id}.jpg`;

  const copy = (text, label) => {
    navigator.clipboard.writeText(text).then(
      () => toast.success(`${label} copied to clipboard`),
      () => toast.error(`Couldn't copy ${label.toLowerCase()}`)
    );
  };

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Black Dollars United — Shop the Movement",
          text: asset.caption,
          url: "https://blackdollarsunited.org",
        });
      } catch {
        /* user cancelled */
      }
    } else {
      copy(asset.caption + "\n\nhttps://blackdollarsunited.org", "Caption + URL");
    }
  };

  const regenerate = async () => {
    if (!window.confirm("Regenerate the flyer from the latest merch photos? Existing flyer will be overwritten.")) return;
    setRegenBusy(true);
    try {
      const { data } = await api.post("/admin/marketing/regenerate_flyer");
      toast.success(`Flyer regenerated · ${Math.round((data.bytes || 0) / 1024)} KB`);
      const img = document.querySelector(`img[data-testid="flyer-preview-${asset.id}"]`);
      if (img) img.src = `${fullUrl}?t=${Date.now()}`;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Regenerate failed");
    } finally {
      setRegenBusy(false);
    }
  };

  return (
    <div className="grid lg:grid-cols-[minmax(0,1fr)_400px] gap-8" data-testid={`asset-card-${asset.id}`}>
      <div className="border border-bdu-gold/20 bg-bdu-surface p-3">
        {isVideo ? (
          <video
            src={fullUrl}
            poster={asset.poster ? `${BACKEND}${asset.poster}` : undefined}
            controls
            playsInline
            className="w-full h-auto"
            data-testid={`flyer-preview-${asset.id}`}
          />
        ) : (
          <img
            src={fullUrl}
            alt={asset.title}
            className="w-full h-auto"
            data-testid={`flyer-preview-${asset.id}`}
          />
        )}
      </div>
      <div className="space-y-5">
        <div>
          <h3 className="font-serif text-2xl text-bdu-cream">{asset.title}</h3>
          <div className="text-xs uppercase tracking-widest text-bdu-gold mt-1">{asset.subtitle}</div>
          <p className="mt-3 text-bdu-cream/70 text-sm leading-relaxed">{asset.description}</p>
        </div>

        <div className="grid grid-cols-2 gap-2">
          <a
            href={fullUrl}
            download={downloadName}
            className="btn-gold text-xs inline-flex items-center justify-center gap-2 py-3"
            data-testid={`flyer-download-${asset.id}`}
          >
            <Download size={14} /> Download {isVideo ? "MP4" : "JPG"}
          </a>
          <button
            onClick={share}
            className="btn-ghost text-xs inline-flex items-center justify-center gap-2 py-3"
            data-testid={`flyer-share-${asset.id}`}
          >
            <Share2 size={14} /> Share
          </button>
          <button
            onClick={() => copy(asset.caption, "Caption")}
            className="btn-ghost text-xs inline-flex items-center justify-center gap-2 py-3"
            data-testid={`flyer-copy-caption-${asset.id}`}
          >
            <Copy size={14} /> Copy Caption
          </button>
          <button
            onClick={() => copy(fullUrl, isVideo ? "Video URL" : "Image URL")}
            className="btn-ghost text-xs inline-flex items-center justify-center gap-2 py-3"
            data-testid={`flyer-copy-url-${asset.id}`}
          >
            <ExternalLink size={14} /> Copy {isVideo ? "Video" : "Image"} URL
          </button>
        </div>

        <div className="border border-bdu-gold/10 bg-bdu-bg p-4">
          <div className="label-eyebrow mb-2" style={{ fontSize: "0.6rem" }}>Ready-to-Paste Caption</div>
          <p className="text-bdu-cream/80 text-xs leading-relaxed whitespace-pre-line">{asset.caption}</p>
        </div>

        {!isVideo && (
          <button
            onClick={regenerate}
            disabled={regenBusy}
            className="text-xs uppercase tracking-widest border border-bdu-cream/20 text-bdu-cream/70 hover:text-bdu-cream hover:border-bdu-cream/40 px-3 py-2 disabled:opacity-50"
            title="Rebuild the flyer using the current active merch catalog (pulls the latest product photos)."
            data-testid={`flyer-regenerate-${asset.id}`}
          >
            {regenBusy ? "Rebuilding…" : "⟳ Regenerate from latest merch"}
          </button>
        )}
      </div>
    </div>
  );
}
